import { Component, OnInit } from '@angular/core';
import { CommonModule } from '@angular/common';
import { TranslateModule } from '@ngx-translate/core';
import {
  ChainSettingsState,
  RebalancingRepository,
  RebalancingState,
  SettingsRepository,
} from '../../../repository';
import { NgIcon } from '@ng-icons/core';
import {
  Asset,
  AssetRepository,
  BLOCK_EXPLORER_TOKEN_LINK,
  Chain,
  ChainRepository,
  TokenLogoComponent,
} from 'common';
import { AddressUtil } from '@31third/common';

@Component({
  selector: 'common-rebalancing-issues',
  standalone: true,
  imports: [CommonModule, TranslateModule, NgIcon, TokenLogoComponent],
  templateUrl: './issues.component.html',
  styleUrls: ['./issues.component.scss'],
})
export class IssuesComponent implements OnInit {
  public BLOCK_EXPLORER_TOKEN_LINK = BLOCK_EXPLORER_TOKEN_LINK;

  public isPriceImpactExceeded = false;
  public maxPriceImpact: number | undefined;
  public actualPriceImpact: number | undefined;
  public relevantAssets: Asset[];
  public chain: Chain | undefined;

  constructor(
    private readonly settingsRepository: SettingsRepository,
    private readonly rebalancingRepository: RebalancingRepository,
    private readonly assetRepository: AssetRepository,
    private readonly chainRepository: ChainRepository,
  ) {}

  public get activeChainSettingsState(): ChainSettingsState | undefined {
    return this.settingsRepository.getActiveChainSetting();
  }

  public get rebalancingState(): RebalancingState {
    return this.rebalancingRepository.store.getValue();
  }

  public ngOnInit(): void {
    this.setupRebalancingListener();
    this.setupChainListener();
  }

  private setupRebalancingListener(): void {
    this.rebalancingRepository.rebalancing$.subscribe(rebalancing => {
      this.isPriceImpactExceeded = false;
      this.maxPriceImpact = undefined;
      this.actualPriceImpact = undefined;
      this.relevantAssets = [];

      if (rebalancing) {
        this.maxPriceImpact = this.activeChainSettingsState?.maxPriceImpact;
        this.actualPriceImpact = rebalancing.maxImpact;

        if (this.maxPriceImpact && this.actualPriceImpact) {
          this.isPriceImpactExceeded =
            this.actualPriceImpact > this.maxPriceImpact;

          const assets = this.assetRepository.store.getValue().assets;
          assets.forEach(asset => {
            if (
              rebalancing.trades.find(
                trade =>
                  AddressUtil.equals(asset.token.address, trade.from.address) ||
                  AddressUtil.equals(asset.token.address, trade.to.address),
              )
            ) {
              this.relevantAssets.push(asset);
            }
          });
        }
      }
    });
  }

  private setupChainListener(): void {
    this.chainRepository.chain$.subscribe(chain => (this.chain = chain));
  }
}
